/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown>, count: NonNullable<unknown> }} Inventory_Products_Bulk_SuccessInputs */

const en_inventory_products_bulk_success = /** @type {(inputs: Inventory_Products_Bulk_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action} ${i?.count} product(s)`)
};

const es_inventory_products_bulk_success = /** @type {(inputs: Inventory_Products_Bulk_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.action} ${i?.count} producto(s)`)
};

/**
* | output |
* | --- |
* | "{action} {count} product(s)" |
*
* @param {Inventory_Products_Bulk_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_products_bulk_success = /** @type {((inputs: Inventory_Products_Bulk_SuccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Products_Bulk_SuccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_products_bulk_success(inputs)
	return es_inventory_products_bulk_success(inputs)
});